export default "/static/empty/no-vaccine.png"